import store from "../../Redux/store";
import ChatModel from "../Domain/Chat.model";
import { setChatList } from "../Infrastructure/Chat.reducer";
import { getChatsByUserIdService } from "../Infrastructure/Chat.service";

export default async function listChats(userID) {
  const data = await getChatsByUserIdService(userID);
  const { items } = data.listChatUsers;
  const chats = items.map(
    (chat) => new ChatModel({ ...chat, ...chat.user_id })
  );
  store.dispatch(setChatList(chats));
  return chats;
}
